export { default } from './ModalReminderResetPassword';
